export default "__VITE_ASSET__52d77c35__"